import RecallListTable from './recallListTable.container';

export default RecallListTable